import SiafLiteApiRepository from "../../external/siafLiteApi";

class BancosCaixasResponsaveisService {
  constructor() {
    this.urlBase = "/financeiro/bancos-caixas-responsaveis";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }
}

export default BancosCaixasResponsaveisService;
